<template>
  <div>
    <h4>Chart Experiments</h4>
    <p>All these are the SAME control</p>
    <b-row class="col-md-12">
      <b-col>
        <hourly-chart chartstyle="width:300px;" title="Hourly Chart" titlestyle="color:green;" :chartData="hourlySales" :labelStyle=0 :labels="labels"></hourly-chart>
      </b-col>
      <b-col>
        <hourly-chart chartstyle="width:300px;" title="Simple Label Type" titlestyle="color:blue;" :chartData="hourlySales" :labelStyle=1 :labels="labels"></hourly-chart>
      </b-col>
      <b-col>
        <hourly-chart charttype='line' filltype="bottom" chartstyle="width:500px;" title="Snack Chart" titlestyle="color:salmon;" :chartData="hourlySales" :labelStyle=2 :labels="labels"></hourly-chart>
      </b-col>
      <b-col>
        <div style="width:500px;margin-left:auto;margin-right:auto;">
          <h4>2019 Github Commits</h4>
          <line-chart :chartData="githubdata" :options="options1">
          </line-chart>
        </div>
      </b-col>
    </b-row>


  </div>
</template>

<script>


  import LineChart   from "./../components/basecharts/LineChart.vue"; // use lib function directly
  import HourlyChart from "./../components/HourlyChart.vue"; // use "generic" control

  export default {
    components: {
      LineChart,
      HourlyChart
    },
    data() {
      return {
        timer      : '',
        options1   : {
          responsive         : true,    // NOT working :(
          maintainAspectRatio: false,
          scales             : {
            xAxes: [ {
              stacked: true
            } ],
            yAxes: [ {
              stacked: true
            } ]
          }
        },
        labels     : [ '', '', 'breakfast', '', 'snack 1', '', 'lunch', '', '', '', 'snack 2', '', '', '', 'dinner', '', '', '', 'late', '', '' ],
        hourlySales: [
          {
            label               : "Cafe",
            backgroundColor     : 'rgba(255,0,0,.3)',
            hoverBackgroundColor: 'rgba(255,0,0,.5)',
            data                : [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23 ]
          },
          {
            label               : "Restaurant",
            backgroundColor     : 'rgba(0,255,0,.2)',
            hoverBackgroundColor: 'rgba(0,255,0,.5)',
            data                : [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23 ]
          },
          {
            label               : "Salon",
            backgroundColor     : 'rgba(0,0,255,.2)',
            hoverBackgroundColor: 'rgba(0,0,255,.5)',
            data                : [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23 ]
          }
        ],
        githubdata : {
          loopCounter: 1,
          labels     : [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ],

          datasets: [
            {
              label          : 'Wolf',
              borderColor    : 'rgba(31,141,193,1)',
              borderWidth    : .5,
              backgroundColor: 'rgba(31,141,193,0.2)', // #1f8dc1',
              data           : [ 40, 49, 31, 39, 58, 40, 65, 77, 40, 20, 0, 0, 0 ]
            }
          ]
        }
      }
    },
    created() {
      // this.timer = setInterval(this.doUpdate, 3000);
    },
    mounted() {
    },
    beforeDestroy() {
      // clearInterval(this.timer)
    },
    methods   : {
      // doUpdate() {
      //   let t = this;
      //   t.githubdata.datasets[ 0 ].data[ 9 ] += Math.floor(Math.random() * 10);
      //   t.githubdata.loopCounter++;
      //   console.log(t.githubdata.datasets[ 0 ].data[ 9 ], t.githubdata.loopCounter);
      // }
    }
  }
</script>
<style>


</style>
